module.exports = __webpack_public_path__ + "kr.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/kr.svg
// module id = 900
// module chunks = 0